import { Box, Popper, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTextField = styled(TextField)(({ theme, containerStyle }) => ({
  width: "100%",
  "& .MuiInputBase-input": {
    fontSize: "12px",
    fontWeight: "100",
    "&::placeholder": {
      fontSize: "12px",
    },
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "5px",
    "&.Mui-focused fieldset": {
      borderColor: "#90b1f7", // Set the border color to blue on focus
      boxShadow: "0 0 0 2px #90b1f7",
    },
  },
  "& .MuiInputBase-root": {
    height: 35, // Custom height
  },
  "& .MuiOutlinedInput-input": {
    padding: "14.5px 14px", // Adjust padding to center the text
  },
}));

const StyledTypography = styled(Typography)(({ theme, typostyle }) => ({
  fontWeight: "400",
  color: typostyle?.color,
  fontSize: typostyle?.fontSize,
}));

const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%",
}));

const StyledAutocompletePopper = styled(Popper)({
  "& .MuiAutocomplete-paper": {
    backgroundColor: "#fafafa",
    borderRadius: 5,
  },
  "& .MuiAutocomplete-option": {
    fontSize: "12px",
    "&:hover": {
      backgroundColor: "#e8eefc",
    },
  },
});

export { StyledTextField, StyledTypography, StyledBox, StyledAutocompletePopper };
